import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
    apiKey: "AIzaSyBgOzEzVr01CnKeN7YdQRCGcz95QyVc90A",
    authDomain: "church-fdc4c.firebaseapp.com",
    projectId: "church-fdc4c",
    storageBucket: "church-fdc4c.firebasestorage.app",
    messagingSenderId: "540212078434",
    appId: "1:540212078434:web:bc0b8dc4b7b6203c926e3b",
    measurementId: "G-QEZ6MJPYVN"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);

export { db, storage, auth }; 